module.exports = __webpack_public_path__ + "img/sib.c79d371a.jpg";